import './App.css';
import React, {Fragment, useEffect} from "react";
import NavBar from "../pages/NavBar/NavBar";
import Home from "../pages/Home/Home";
import AboutME from "../pages/About/AboutME";
import Services from "../pages/Services/Services";
import Projects from "../pages/Projects/Projects";
import Certificates from "../pages/Certificates/Certificates";
import Contact from "../pages/Contact/Contact";
import {useState, CSSProperties} from "react";
import GridLoader from "react-spinners/GridLoader";


function App() {


    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }, [])

    return (
        <Fragment>
            <div>
                {loading ? (
                    <div className='spinnerContainer'>
                        <GridLoader color={'#ff014f'} loading={loading} size={40}/>
                    </div>

                ) : (
                    <div>
                        <NavBar/>
                        <Home/>
                        <AboutME/>
                        <Services/>
                        <Projects/>
                        <Certificates/>
                        <Contact/>
                    </div>
                )}
            </div>
        </Fragment>
    );
}

export default App;
